import { useQuery } from '@tanstack/react-query';

import { ICON_URL_STALE_TIME } from '../../app/constants';
import { queryClient } from '../../api/queryClient';
import {
  getV1InviteToJoinByIdOptions,
  getV1InvitesToJoinOptions,
  getV1UserByIdOptions,
  getV1UsersOptions,
  getV1UsersQueryKey,
} from '../../api/generated/pap/@tanstack/react-query.gen';

/**
 * Query hooks for the Users page: the Users list, one User's details, the
 * Invites to Join the current Business Partner has sent out, and one such
 * invite's details. See `../Settings/IdentityProviders/identityProviders.queries.ts`
 * for the pattern.
 */

/** Users of the current Business Partner plus its (virtual) Owner. */
export const useUsers = (isUserAdmin: boolean = true) =>
  useQuery({
    ...getV1UsersOptions(),
    enabled: isUserAdmin,
  });

/** Clears the Users list. */
export const invalidateUsers = () =>
  queryClient.invalidateQueries({ queryKey: getV1UsersQueryKey() });

export const useUserDetails = (id?: string) =>
  useQuery({
    ...getV1UserByIdOptions({ path: { id: id as string } }),
    enabled: !!id,
  });

/** Pending Invites to Join sent by the current Business Partner. Resolves to the `items` array. */
export const useInvitations = (isUserAdmin: boolean = true) =>
  useQuery({
    ...getV1InvitesToJoinOptions(),
    select: (data) => data.items,
    enabled: isUserAdmin,
    staleTime: ICON_URL_STALE_TIME,
    refetchOnMount: true,
  });

export const useInvitationDetails = (id?: string) =>
  useQuery({
    ...getV1InviteToJoinByIdOptions({ path: { id: id as string } }),
    enabled: !!id,
  });
